import { useContext, useEffect, useState, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { WorkTabContext } from './work-tab-context';

/** Keep the same controls mounted while giving the workbench list room for records. */
export function WorkListTools({ children }: { children: ReactNode }): JSX.Element {
  const { companion } = useContext(WorkTabContext);
  const { t } = useTranslation();
  const [open, setOpen] = useState(!companion);
  useEffect(() => setOpen(!companion), [companion]);
  return (
    <details
      className="work-list-tools"
      data-compact={companion}
      open={open}
      onToggle={(event) => setOpen(event.currentTarget.open)}
    >
      <summary className="min-h-11 cursor-pointer rounded-md border border-border px-3 py-2 text-sm">
        {t('workTabs.tools')}
      </summary>
      <div className="space-y-3">{children}</div>
    </details>
  );
}
